import API from "../../Data/Domain/API";
import URL from "../../Data/Domain/URL";
import { URLPatchSelector } from "../Domain/URLPatchSelector";

export async function patchDoubleClickEditLabel({ type, id, id_resource }, patchData) {
  const relativePath = URLPatchSelector.select({ type, id, id_resource });
  const fullUrl = URL.buildUrl(relativePath); 

  return await new API(fullUrl).patch(patchData);
}
